import { render, staticRenderFns } from "./araging.vue?vue&type=template&id=925616a2"
import script from "./araging.vue?vue&type=script&lang=js"
export * from "./araging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports